"use client";
import SvgAddFilled from "./add-filled.svg.js";
import SvgAddOutlined from "./add-outlined.svg.js";
import SvgAddRound from "./add-round.svg.js";
import SvgAddSharp from "./add-sharp.svg.js";
import SvgAutoFilled from "./auto-filled.svg.js";
import SvgAutoOutlined from "./auto-outlined.svg.js";
import SvgAutoRound from "./auto-round.svg.js";
import SvgAutoSharp from "./auto-sharp.svg.js";
import SvgBackspaceFilled from "./backspace-filled.svg.js";
import SvgBackspaceOutlined from "./backspace-outlined.svg.js";
import SvgBackspaceRound from "./backspace-round.svg.js";
import SvgBackspaceSharp from "./backspace-sharp.svg.js";
import SvgClearFilled from "./clear-filled.svg.js";
import SvgClearOutlined from "./clear-outlined.svg.js";
import SvgClearRound from "./clear-round.svg.js";
import SvgClearSharp from "./clear-sharp.svg.js";
import SvgMailFilled from "./mail-filled.svg.js";
import SvgMailOutlined from "./mail-outlined.svg.js";
import SvgMailRound from "./mail-round.svg.js";
import SvgMailSharp from "./mail-sharp.svg.js";
import SvgManageAccountFilled from "./manage_account-filled.svg.js";
import SvgManageAccountOutlined from "./manage_account-outlined.svg.js";
import SvgManageAccountRound from "./manage_account-round.svg.js";
import SvgManageAccountSharp from "./manage_account-sharp.svg.js";
import SvgPersonFilled from "./person-filled.svg.js";
import SvgPersonOutlined from "./person-outlined.svg.js";
import SvgPersonRound from "./person-round.svg.js";
import SvgPersonSharp from "./person-sharp.svg.js";
import SvgRemoveFilled from "./remove-filled.svg.js";
import SvgRemoveOutlined from "./remove-outlined.svg.js";
import SvgRemoveRound from "./remove-round.svg.js";
import SvgRemoveSharp from "./remove-sharp.svg.js";
import SvgSendFilled from "./send-filled.svg.js";
import SvgSendOutlined from "./send-outlined.svg.js";
import SvgSendRound from "./send-round.svg.js";
import SvgSendSharp from "./send-sharp.svg.js";
import SvgWorkFilled from "./work-filled.svg.js";
import SvgWorkOutlined from "./work-outlined.svg.js";
import SvgWorkRound from "./work-round.svg.js";
import SvgWorkSharp from "./work-sharp.svg.js";
const add = {
  filled: SvgAddFilled,
  outlined: SvgAddOutlined,
  round: SvgAddRound,
  sharp: SvgAddSharp
};
const auto = {
  filled: SvgAutoFilled,
  outlined: SvgAutoOutlined,
  round: SvgAutoRound,
  sharp: SvgAutoSharp
};
const backspace = {
  filled: SvgBackspaceFilled,
  outlined: SvgBackspaceOutlined,
  round: SvgBackspaceRound,
  sharp: SvgBackspaceSharp
};
const clear = {
  filled: SvgClearFilled,
  outlined: SvgClearOutlined,
  round: SvgClearRound,
  sharp: SvgClearSharp
};
const mail = {
  filled: SvgMailFilled,
  outlined: SvgMailOutlined,
  round: SvgMailRound,
  sharp: SvgMailSharp
};
const manage_account = {
  filled: SvgManageAccountFilled,
  outlined: SvgManageAccountOutlined,
  round: SvgManageAccountRound,
  sharp: SvgManageAccountSharp
};
const person = {
  filled: SvgPersonFilled,
  outlined: SvgPersonOutlined,
  round: SvgPersonRound,
  sharp: SvgPersonSharp
};
const remove = {
  filled: SvgRemoveFilled,
  outlined: SvgRemoveOutlined,
  round: SvgRemoveRound,
  sharp: SvgRemoveSharp
};
const send = {
  filled: SvgSendFilled,
  outlined: SvgSendOutlined,
  round: SvgSendRound,
  sharp: SvgSendSharp
};
const work = {
  filled: SvgWorkFilled,
  outlined: SvgWorkOutlined,
  round: SvgWorkRound,
  sharp: SvgWorkSharp
};
export {
  add,
  auto,
  backspace,
  clear,
  mail,
  manage_account,
  person,
  remove,
  send,
  work
};
